import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SuppliersReducer(state = initialState.suppliers, action: any) {
  switch (action.type) {
    case types.SAVE_SUPPLIERS_SUCCESS:
      
      return action.suppliers;
    default:
      return state;
  }
}
